.screen-container {
  position: relative;
  padding: 32px 5px;
  display: flex;
  flex-direction: column;
  z-index: 102;
  overflow: auto;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}

.is-mobile-viewport .screen-container {
  max-height: var(--mobile-max-height);
}

.content-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  max-width: 430px;
  height: auto;
  align-self: center;
  justify-content: space-between;
  gap: 20px;
  width: 100%;
}

.content-inner {
  flex-grow: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
}

.copy-container {
  display: flex;
  flex-direction: column;
  padding: 0 20px 0;
  gap: 12px;
  justify-content: flex-end;
}

.title {
  overflow-wrap: break-word;
  white-space: pre-wrap;
}

.title h1 {
  margin: 0;
  font-weight: normal;
  width: 100%;
}

.body {
  overflow-wrap: break-word;
  white-space: pre-wrap;
}

.body p {
  margin: 0;
  width: 100%;
}

.cta-section {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 298px;
  width: 298px;
  margin: 24px auto 0;
}

.cta-wrapper {
  width: 100%;
}

.notification-cta {
  width: 100%;
  background-color: var(--cta-bg-color);
  border-radius: calc(var(--cta-border-radius, 0) * 1px);
  cursor: pointer;
  height: 51px;
  border-style: solid;
  border-width: calc(var(--cta-border-width, 0) * 1px);
  border-color: var(--cta-border-color, transparent);
  padding: 0;
  white-space: pre-wrap;
}

/* Reset for HTML content inside CTA buttons */
.notification-cta p {
  margin: 0;
}

.notification-cta * {
  pointer-events: none;
}

/* Mobile responsive - match acquisition behavior */
.is-mobile-viewport .content-area {
  width: 100% !important;
}

.is-mobile-viewport .body {
  margin-bottom: 0;
}

.is-mobile-viewport .cta-section {
  gap: 8px;
  max-width: 100%;
}

.is-mobile-viewport .notification-cta {
  padding: 12px 24px;
}

.is-mobile-viewport :host,
.is-mobile-viewport .screen-container {
  max-width: var(--mobile-max-width);
  min-width: var(--mobile-min-width);
}
